<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaEquipos
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 80px;border-radius:5px')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Equipos Quiniela
    v-layout(align-start='' justify-start='' row='' wrap='' fill-height='')
      v-flex(xs12 style='margin-top: 5px;display:flex;justify-content:flex-end;padding:0 10px;')
        v-btn(color='blue darken-2' dark='' small='' @click='abrirImportar' style='margin-right:8px;')
          v-icon(left='') cloud_download
          | Importar desde API Mundial
        v-btn(color='#fe0100' dark='' small='' @click='abrirCrear')
          v-icon(left='') add
          | Nuevo Equipo
      v-flex(xs12 style='margin-top: 5px;')
        v-card(style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Lista de Equipos
        v-data-table.elevation-1(:headers='headers' :items='equipos' style='margin-top:5px;')
          template(slot='items' slot-scope='props')
            td
              img(v-if='props.item.bandera_url' :src='props.item.bandera_url' style='height:28px;width:auto;vertical-align:middle;')
            td {{ props.item.codigo }}
            td {{ props.item.nombre }}
            td {{ props.item.grupo || '—' }}
            td
              v-chip(:color="props.item.activo ? 'green' : 'grey'" text-color='white' small='') {{ props.item.activo ? 'Activo' : 'Inactivo' }}
            td
              v-btn(icon='' @click='editar(props.item)')
                v-icon(color='blue') edit
              v-btn(icon='' @click='confirmarEliminar(props.item)')
                v-icon(color='red') delete

  //─── Modal Crear / Editar ───────────────────────────────────────────────────
  v-dialog(v-model='dialog' max-width='500px' persistent='')
    v-card
      v-card-title
        span.headline {{ editando ? 'Editar Equipo' : 'Nuevo Equipo' }}
      v-card-text
        v-form(ref='form')
          v-text-field(v-model='form.codigo' label='Código FIFA' :rules='[r => !!r || "Requerido"]' outlined='' dense='')
          v-text-field(v-model='form.nombre' label='Nombre' :rules='[r => !!r || "Requerido"]' outlined='' dense='')
          v-text-field(v-model='form.bandera_url' label='URL Bandera' outlined='' dense='')
          v-text-field(v-model='form.grupo' label='Grupo (A-H)' outlined='' dense='')
          v-switch(v-model='form.activo' label='Activo' color='green')
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialog = false') Cancelar
        v-btn(color='#fe0100' dark='' @click='guardar' :loading='loading') Guardar

  //─── Modal Importar ─────────────────────────────────────────────────────────
  v-dialog(v-model='dialogImportar' max-width='700px' persistent='')
    v-card
      v-card-title
        span.headline Importar Equipos desde API
        v-spacer
        v-progress-circular(v-if='loadingApi' indeterminate='' color='blue' size='24')
      v-card-text
        div(v-if='!equiposApi.length && !loadingApi' style='text-align:center;padding:30px;')
          span No se obtuvieron datos de la API.
        div(v-if='equiposApi.length')
          v-layout(align-center='' wrap='')
            v-flex(xs12 style='margin-bottom:8px;')
              v-btn(small='' text='' @click='selTodos') Seleccionar todos
              v-btn(small='' text='' @click='deselTodos' style='margin-left:4px;') Deseleccionar
            v-flex(xs12)
              v-data-table(:headers='headersApi' :items='equiposApi' hide-actions='')
                template(slot='items' slot-scope='props')
                  td
                    v-checkbox(v-model='seleccionados' :value='props.item' hide-details='' style='margin:0;')
                  td
                    img(:src='props.item.bandera_url' style='height:24px;width:auto;vertical-align:middle;')
                  td {{ props.item.codigo }}
                  td {{ props.item.nombre }}
                  td {{ props.item.grupo }}
                  td
                    v-chip(:color="props.item._existe ? 'orange' : 'green'" text-color='white' small='')
                      | {{ props.item._existe ? 'Ya existe' : 'Nuevo' }}
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialogImportar = false') Cancelar
        v-btn(color='blue darken-2' dark='' @click='importarSeleccionados' :loading='loading' :disabled='!seleccionados.length') Importar ({{ seleccionados.length }})

  //─── Confirmar Eliminar ─────────────────────────────────────────────────────
  v-dialog(v-model='dialogEliminar' max-width='360px')
    v-card
      v-card-title
        span.headline Confirmar
      v-card-text ¿Eliminar el equipo "{{ itemEliminar && itemEliminar.nombre }}"?
      v-card-actions
        v-spacer
        v-btn(text='' @click='dialogEliminar = false') Cancelar
        v-btn(color='red' dark='' @click='eliminar' :loading='loading') Eliminar

  //─── Waiting ────────────────────────────────────────────────────────────────
  v-dialog(v-model='dialog4' persistent='' max-width='400px')
    v-container(style='max-width:400px;background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-flex(xs12)
          v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h4.black--text Esperando Respuesta del Servidor.!!
            v-flex(xs12)
              div(style='display:flex;justify-content:center;').text-xs-center
                img(src='../assets/waiting.gif' width='200' height='150')
            v-flex(xs12)
              v-card-title(style='padding:7px;').justify-center
                h5.black--text Por favor espere...
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaEquipos',
  data: () => ({
    equipos: [],
    dialog: false,
    dialogImportar: false,
    dialogEliminar: false,
    dialog4: false,
    loading: false,
    loadingApi: false,
    editando: false,
    itemEliminar: null,
    equiposApi: [],
    seleccionados: [],
    form: {
      codigo: '',
      nombre: '',
      bandera_url: '',
      grupo: '',
      activo: true
    },
    headers: [
      { text: 'Bandera', sortable: false },
      { text: 'Código', value: 'codigo' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Estado', sortable: false },
      { text: 'Acciones', sortable: false }
    ],
    headersApi: [
      { text: '', sortable: false },
      { text: 'Bandera', sortable: false },
      { text: 'Código', value: 'codigo' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Estado', sortable: false }
    ]
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      Api.get('quiniela/equipos').then(res => {
        this.equipos = res.data || []
      })
    },
    abrirCrear () {
      this.editando = false
      this.form = { codigo: '', nombre: '', bandera_url: '', grupo: '', activo: true }
      this.dialog = true
    },
    editar (item) {
      this.editando = true
      this.form = Object.assign({}, item)
      this.dialog = true
    },
    guardar () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      const req = this.editando
        ? Api.put('quiniela/equipos', this.form)
        : Api.post('quiniela/equipos', this.form)
      req.then(() => {
        this.dialog = false
        this.initialize()
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al guardar', 'error')
      }).finally(() => { this.loading = false })
    },
    confirmarEliminar (item) {
      this.itemEliminar = item
      this.dialogEliminar = true
    },
    eliminar () {
      this.loading = true
      Api.delete('quiniela/equipos/' + this.itemEliminar._id).then(() => {
        this.dialogEliminar = false
        this.initialize()
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al eliminar', 'error')
      }).finally(() => { this.loading = false })
    },
    abrirImportar () {
      this.equiposApi = []
      this.seleccionados = []
      this.dialogImportar = true
      this.loadingApi = true
      Api.get('quiniela/equipos/fetch-api').then(res => {
        const teams = res.data.teams || res.data || []
        this.equiposApi = teams.map(t => ({
          codigo: t.fifa_code,
          nombre: t.name_en,
          bandera_url: t.flag,
          grupo: t.groups || '',
          activo: true,
          _existe: this.equipos.some(e => e.codigo === t.fifa_code),
          _id_existente: (this.equipos.find(e => e.codigo === t.fifa_code) || {})._id
        }))
        this.seleccionados = this.equiposApi.slice()
      }).catch(() => {
        this.$swal('Error', 'No se pudo conectar con la API externa', 'error')
        this.dialogImportar = false
      }).finally(() => { this.loadingApi = false })
    },
    selTodos () { this.seleccionados = this.equiposApi.slice() },
    deselTodos () { this.seleccionados = [] },
    importarSeleccionados () {
      this.loading = true
      const ops = this.seleccionados.map(t => {
        const payload = {
          codigo: t.codigo,
          nombre: t.nombre,
          bandera_url: t.bandera_url,
          grupo: t.grupo,
          activo: t.activo
        }
        if (t._existe && t._id_existente) {
          return Api.put('quiniela/equipos', { ...payload, _id: t._id_existente })
        } else {
          return Api.post('quiniela/equipos', payload)
        }
      })
      Promise.all(ops).then(() => {
        this.dialogImportar = false
        this.initialize()
        this.$swal('Listo', `${ops.length} equipos importados correctamente`, 'success')
      }).catch(e => {
        this.$swal('Error', (e.response && e.response.data && e.response.data.message) || 'Error al importar', 'error')
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
